/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscogsSearchArtistsInnerAliasesInner
 */
export interface DiscogsSearchArtistsInnerAliasesInner {
    /**
     * 
     * @type {string}
     * @memberof DiscogsSearchArtistsInnerAliasesInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DiscogsSearchArtistsInnerAliasesInner
     */
    name: string;
}

/**
 * Check if a given object implements the DiscogsSearchArtistsInnerAliasesInner interface.
 */
export function instanceOfDiscogsSearchArtistsInnerAliasesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function DiscogsSearchArtistsInnerAliasesInnerFromJSON(json: any): DiscogsSearchArtistsInnerAliasesInner {
    return DiscogsSearchArtistsInnerAliasesInnerFromJSONTyped(json, false);
}

export function DiscogsSearchArtistsInnerAliasesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscogsSearchArtistsInnerAliasesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function DiscogsSearchArtistsInnerAliasesInnerToJSON(value?: DiscogsSearchArtistsInnerAliasesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

